export default "__VITE_ASSET__bf3bd934__"